import React, {useEffect, useMemo} from 'react';
import {useEthers} from '@usedapp/core';
import {useScopeTranslation} from '@uigstudio/uig-nextjs-helper';

import {If} from '~atoms/If';
import OpenSeaButton from '~atoms/OpenSeaButton';
import usePlotNFT from '~hooks/usePlotNFT';
import useMintPlotNFT from '~hooks/useMintPlotNFT';

import {Container, StyledButton} from './styles';

type PlotNFTProps = {
    isLand: boolean;
    owner: string | undefined;
    id: number;
    marginTop?: number;
    setDisplayBanner?: (v: boolean) => void;
};
const PlotNFT = ({
    isLand,
    owner,
    id,
    marginTop = 16,
    setDisplayBanner,
}: PlotNFTProps) => {
    const t = useScopeTranslation('common', 'mint');
    const {account} = useEthers();
    const {plotNFTExists, plotNFTExistsLoading} = usePlotNFT(id, isLand);
    const {mintPlot, mintLoading, proofLoading, proof} = useMintPlotNFT(id);

    const isOwner = useMemo(
        () =>
            owner && account ? owner.toLowerCase() === account.toLowerCase() : false,
        [owner, account],
    );
    const canMint = useMemo(() => {
        if (plotNFTExists) {
            return false;
        }
        return isOwner;
    }, [isOwner, plotNFTExists]);

    const globalLoading = useMemo(
        () => plotNFTExistsLoading || proofLoading,
        [plotNFTExistsLoading, proofLoading],
    );

    useEffect(() => {
        if (setDisplayBanner) {
            if (isOwner) {
                setDisplayBanner(true);
            } else if (!globalLoading && plotNFTExists === false) {
                setDisplayBanner(false);
            }
        }
    }, [globalLoading]);

    return (
        <Container marginTop={marginTop}>
            {globalLoading ? (
                <StyledButton loading={globalLoading} disabled={true}>
                    {'.'}
                </StyledButton>
            ) : (
                <>
                    <If condition={plotNFTExists}>
                        <OpenSeaButton id={id} />
                    </If>
                    <If condition={canMint}>
                        <StyledButton
                            variant="stroked"
                            loading={mintLoading}
                            disabled={mintLoading || !Boolean(proof)}
                            onClick={(e: Event) => {
                                e.preventDefault();
                                mintPlot();
                            }}
                        >
                            {t('mintPlotNFT')}
                        </StyledButton>
                    </If>
                </>
            )}
        </Container>
    );
};
export default PlotNFT;
